import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Redirect } from "react-router";
import ProductDetailPart1 from "./ProductDetailPart1";
import ProductDetailPart2 from "./ProductDetailPart2";
import { editProduct, productProperties, saveProduct } from "./services";

class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      pending: false,
      redirect: false,
      pageMode:
        (window.location.pathname.split("/")[3] === "p" &&
          window.location.pathname.split("/").length === 5 &&
          window.location.pathname.split("/")[4] !== "set-price") ||
        window.location.pathname.split("/").length === 6
          ? "edit"
          : "add",
      title: "",
      des: "",
      part: 1,
      category: null,
      cover: null,
      time: null,
      price: "",
      payablePrice: "",
      has_stock: true,
      show_on_menu: true,
      need_address: localStorage.getItem("selected_shop")
        ? JSON.parse(localStorage.getItem("selected_shop")).config
            .default_product_need_address
        : true,
      shopUid: window.location.pathname.split("/")[2],
      productMode: window.location.pathname.split("/")[3],
      productId:
        window.location.pathname.split("/")[4] !== "set-price" &&
        window.location.pathname.split("/")[4],
      isActivate:
        this.props.location.state &&
        this.props.location.state.isActivate &&
        true,
      shop_category: "",
    };
  }
  componentDidMount() {
    if (this.state.pageMode === "edit" && this.state.productId) {
      this.getProduct();
    }
    if (
      window.location.pathname.includes("set-price") &&
      !this.state.category &&
      this.state.part === 1
    ) {
      window.location.href = window.location.pathname.replace("/set-price", "");
    }
  }
  componentDidUpdate() {
    if (
      window.location.pathname.includes("set-price") &&
      this.state.part === 1
    ) {
      this.setState({ part: 2 });
    }
    if (
      !window.location.pathname.includes("set-price") &&
      this.state.part === 2
    ) {
      this.setState({ part: 1, redirect: false });
    }
  }
  getProduct() {
    productProperties(this.state.shopUid, this.state.productId).then(
      (items) => {
        items &&
          this.setState({
            title: items.name,
            des: items.des,
            images: items.medias ? items.medias : [],
            category: items.category,
            cover: items.image,
            price: items.price,
            payablePrice: items.payable_price,
            has_stock: items.has_stock,
            show_on_menu: items.show_on_menu,
            need_address: items.need_address,
            time: items.preparation_time,
            shop_category: items?.shop_category,
          });
      }
    );
  }
  edit_product() {
    this.setState({ pending: true });
    var medias = [];
    this.state.images.map((image, i) => medias.push(image.uid));
    let params = {
      name: this.state.title,
      des: this.state.des,
      price: this.state.price,
      payable_price: this.state.payablePrice || -1,
      category: this.state.category?.uid,
      cover: this.state.cover?.uid,
      has_stock: this.state.has_stock,
      show_on_menu: this.state.show_on_menu,
      need_address: this.state.need_address,
      medias: medias,
      preparation_time: this.state.time,
      shop_category: this.state.shop_category?.uid,
    };
    editProduct(this.state.shopUid, this.state.productId, params).then(
      (items) => {
        items &&
          (window.location.href = `/${items.shop.uid}/p/${items.id}?isManager=true`);
      }
    );
  }
  save_product() {
    this.setState({ pending: true });
    var medias = [];
    this.state.images.map((image, i) => medias.push(image.uid));
    let params = {
      name: this.state.title,
      des: this.state.des,
      price: this.state.price,
      category: this.state.category?.uid,
      cover: this.state.cover?.uid,
      has_stock: this.state.has_stock,
      show_on_menu: this.state.show_on_menu,
      need_address: this.state.need_address,
      medias: medias,
      preparation_time: this.state.time,
      payable_price: this.state.payablePrice || -1,
      shop_category: this.state.shop_category?.uid,
    };
    if (this.state.productMode === "cp") {
      params.request = this.state.productId;
    }
    saveProduct(this.state.shopUid, params).then((items) => {
      if (items) {
        if (this.state.isActivate) {
          window.location.href = `/dashboard/${items.shop.uid}/activation`;
        } else {
          window.location.href = `/${items.shop.uid}/p/${items.id}?isManager=true`;
        }
      }
    });
  }

  render() {
    console.log(this.state.pageMode, this.state.part);
    return (
      <div className="container-fluid">
        {this.state.redirect && (
          <Redirect
            push
            to={{
              pathname: `/dashboard/${this.state.shopUid}/p${
                this.state.productId ? "/" + this.state.productId : ""
              }/set-price`,
            }}
          />
        )}
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "1" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">
              {this.state.part === 1
                ? this.state.pageMode === "add"
                  ? this.state.productMode === "p"
                    ? "محصول جدید"
                    : "محصول سفارشی"
                  : "ویرایش محصول"
                : "قیمت"}
            </h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() =>
                this.state.part === 1
                  ? this.setState({ redirect: true })
                  : this.state.pageMode === "add"
                  ? this.save_product()
                  : this.edit_product()
              }
              className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
              disabled={
                this.state.part === 1
                  ? !this.state.des ||
                    !this.state.title ||
                    this.state.images.length === 0 ||
                    (!this.state.category && !this.state.shop_category)
                  : this.state.pending ||
                    !this.state.price ||
                    this.state.price < 1000 ||
                    (this.state.payablePrice &&
                      this.state.payablePrice < 1000) ||
                    this.state.price < this.state.payablePrice
              }
            >
              {this.state.pending ? (
                <div className="spinner-border spinner-border-sm color-second align-middle"></div>
              ) : this.state.part === 1 ? (
                "بعدی"
              ) : (
                "ذخیره"
              )}
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          {this.state.part === 1 ? (
            <ProductDetailPart1
              title={this.state.title}
              titleChange={(title) => this.setState({ title: title })}
              des={this.state.des}
              desChange={(des) => this.setState({ des: des })}
              images={this.state.images}
              imagesChange={(images) => {
                !this.state.cover
                  ? this.setState({ cover: images[0], images: images })
                  : this.setState({ images: images });
              }}
              categoryChange={(category) =>
                this.setState({ category: category })
              }
              shop_category={this.state.shop_category}
              shopCategoryChange={(e) => this.setState({ shop_category: e })}
              category={this.state.category}
              cover={this.state.cover}
              coverChange={(cover) => this.setState({ cover: cover })}
              time={this.state.time}
              timeChange={(time) => this.setState({ time: time })}
            />
          ) : (
            <ProductDetailPart2
              price={this.state.price}
              priceChange={(e) => this.setState({ price: e })}
              payablePrice={this.state.payablePrice}
              payablePriceChange={(e) => this.setState({ payablePrice: e })}
              has_stock={this.state.has_stock}
              has_stock_change={(e) => this.setState({ has_stock: e })}
              show_on_menu={this.state.show_on_menu}
              show_on_menu_change={(e) => this.setState({ show_on_menu: e })}
              need_address={this.state.need_address}
              need_address_change={(e) => this.setState({ need_address: e })}
            />
          )}
        </body>
      </div>
    );
  }
}

export default ProductDetail;
